import request from "@/utils/request";

export default function adminReadMessage(id,adminIsRead) {
    return request({
        url: `/newsMessage/agencyReadMessage/`+id+`/`+adminIsRead,
        method: 'get',
    })
}
